module.exports = __webpack_public_path__ + "assets/chatIcon.b2323a6c.svg";